/**
 * @generated SignedSource<<5df5ab4df6e2841b2f93c8d142d73cce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoredDataProvider_Query$variables = Record<PropertyKey, never>;
export type StoredDataProvider_Query$data = {
  readonly users: ReadonlyArray<{
    readonly id: string;
    readonly imageUrl: string | null;
    readonly isDeleted: boolean;
    readonly name: string;
  }>;
};
export type StoredDataProvider_Query = {
  response: StoredDataProvider_Query$data;
  variables: StoredDataProvider_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "users",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoredDataProvider_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StoredDataProvider_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "053c595d2ea3d0781b6f78ec0fa4ea81",
    "id": null,
    "metadata": {},
    "name": "StoredDataProvider_Query",
    "operationKind": "query",
    "text": "query StoredDataProvider_Query {\n  users {\n    id\n    name\n    imageUrl\n    isDeleted\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f6d587f3569964eed69a575269ccde0";

export default node;
